import { getAuthenticatedAxios, withErrorHandler } from './AuthenticatedAxiosProvider';
import { buildRequestUrl } from '../Config';

export const CreateUser = async (profile) => {
  const url = buildRequestUrl('/api/users/user/create');
  const {data} = await withErrorHandler(() => getAuthenticatedAxios().post(url, profile));

  return data;
};
